import React from "react";

import { useAppSelectionContext } from "@main/context/App/AppSelectionContext";

import { RoutePaths } from "../../config/routePaths";
import RedirectWithLoading from "../RedirectWithLoading";

export const InfoRedirect = () => {
  const { selectedWorkspace } = useAppSelectionContext();

  const dynamicValues = { workspaceSlug: selectedWorkspace?.slug };

  return (
    <RedirectWithLoading
      path={RoutePaths.VIDEOS_ROOT}
      dynamicValues={dynamicValues}
    />
  );
};
